import _definePage_default_0 from '/opt/render/project/src/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/opt/render/project/src/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/opt/render/project/src/src/pages/admin/index.vue?definePage&vue'
import _definePage_default_4 from '/opt/render/project/src/src/pages/admin/acesso/perfis/index.vue?definePage&vue'
import _definePage_default_5 from '/opt/render/project/src/src/pages/admin/auth/cadastrar/index.vue?definePage&vue'
import _definePage_default_6 from '/opt/render/project/src/src/pages/admin/auth/esqueceu-senha/index.vue?definePage&vue'
import _definePage_default_7 from '/opt/render/project/src/src/pages/admin/auth/login/index.vue?definePage&vue'
import _definePage_default_8 from '/opt/render/project/src/src/pages/admin/auth/redefinir-senha/index.vue?definePage&vue'
import _definePage_default_9 from '/opt/render/project/src/src/pages/admin/auth/verificar-email/index.vue?definePage&vue'
import _definePage_default_10 from '/opt/render/project/src/src/pages/admin/banner/index.vue?definePage&vue'
import _definePage_default_11 from '/opt/render/project/src/src/pages/admin/banner/cadastrar/index.vue?definePage&vue'
import _definePage_default_12 from '/opt/render/project/src/src/pages/admin/banner/editar/[id].vue?definePage&vue'
import _definePage_default_13 from '/opt/render/project/src/src/pages/admin/categoria-espaco-evento/index.vue?definePage&vue'
import _definePage_default_14 from '/opt/render/project/src/src/pages/admin/categoria-espaco-evento/cadastrar/index.vue?definePage&vue'
import _definePage_default_15 from '/opt/render/project/src/src/pages/admin/categoria-espaco-evento/editar/[id].vue?definePage&vue'
import _definePage_default_16 from '/opt/render/project/src/src/pages/admin/categoria-experiencia/index.vue?definePage&vue'
import _definePage_default_17 from '/opt/render/project/src/src/pages/admin/categoria-experiencia/cadastrar/index.vue?definePage&vue'
import _definePage_default_18 from '/opt/render/project/src/src/pages/admin/categoria-experiencia/editar/[id].vue?definePage&vue'
import _definePage_default_19 from '/opt/render/project/src/src/pages/admin/categoria-fornecedor/index.vue?definePage&vue'
import _definePage_default_20 from '/opt/render/project/src/src/pages/admin/categoria-fornecedor/cadastrar/index.vue?definePage&vue'
import _definePage_default_21 from '/opt/render/project/src/src/pages/admin/categoria-fornecedor/editar/[id].vue?definePage&vue'
import _definePage_default_22 from '/opt/render/project/src/src/pages/admin/categoria-produto/index.vue?definePage&vue'
import _definePage_default_23 from '/opt/render/project/src/src/pages/admin/categoria-produto/cadastrar/index.vue?definePage&vue'
import _definePage_default_24 from '/opt/render/project/src/src/pages/admin/categoria-produto/editar/[id].vue?definePage&vue'
import _definePage_default_25 from '/opt/render/project/src/src/pages/admin/categoria-servico/index.vue?definePage&vue'
import _definePage_default_26 from '/opt/render/project/src/src/pages/admin/categoria-servico/cadastrar/index.vue?definePage&vue'
import _definePage_default_27 from '/opt/render/project/src/src/pages/admin/categoria-servico/editar/[id].vue?definePage&vue'
import _definePage_default_28 from '/opt/render/project/src/src/pages/admin/comodidade/index.vue?definePage&vue'
import _definePage_default_29 from '/opt/render/project/src/src/pages/admin/comodidade/cadastrar/index.vue?definePage&vue'
import _definePage_default_30 from '/opt/render/project/src/src/pages/admin/comodidade/editar/[id].vue?definePage&vue'
import _definePage_default_31 from '/opt/render/project/src/src/pages/admin/convite/index.vue?definePage&vue'
import _definePage_default_32 from '/opt/render/project/src/src/pages/admin/convite/cadastrar/index.vue?definePage&vue'
import _definePage_default_33 from '/opt/render/project/src/src/pages/admin/dashboard-fornecedor/index.vue?definePage&vue'
import _definePage_default_34 from '/opt/render/project/src/src/pages/admin/data-bloqueada/index.vue?definePage&vue'
import _definePage_default_35 from '/opt/render/project/src/src/pages/admin/data-bloqueada/cadastrar/index.vue?definePage&vue'
import _definePage_default_36 from '/opt/render/project/src/src/pages/admin/data-bloqueada/editar/[id].vue?definePage&vue'
import _definePage_default_37 from '/opt/render/project/src/src/pages/admin/espaco-evento/index.vue?definePage&vue'
import _definePage_default_38 from '/opt/render/project/src/src/pages/admin/espaco-evento/cadastrar/index.vue?definePage&vue'
import _definePage_default_39 from '/opt/render/project/src/src/pages/admin/espaco-evento/editar/[id].vue?definePage&vue'
import _definePage_default_40 from '/opt/render/project/src/src/pages/admin/evento/index.vue?definePage&vue'
import _definePage_default_41 from '/opt/render/project/src/src/pages/admin/evento/cadastrar/index.vue?definePage&vue'
import _definePage_default_42 from '/opt/render/project/src/src/pages/admin/evento/editar/[id].vue?definePage&vue'
import _definePage_default_43 from '/opt/render/project/src/src/pages/admin/fornecedor/index.vue?definePage&vue'
import _definePage_default_44 from '/opt/render/project/src/src/pages/admin/fornecedor/cadastrar/index.vue?definePage&vue'
import _definePage_default_45 from '/opt/render/project/src/src/pages/admin/fornecedor/editar/[id].vue?definePage&vue'
import _definePage_default_46 from '/opt/render/project/src/src/pages/admin/galeria/index.vue?definePage&vue'
import _definePage_default_47 from '/opt/render/project/src/src/pages/admin/meu-plano/index.vue?definePage&vue'
import _definePage_default_48 from '/opt/render/project/src/src/pages/admin/minhas-assinaturas/index.vue?definePage&vue'
import _definePage_default_49 from '/opt/render/project/src/src/pages/admin/patrocinio/index.vue?definePage&vue'
import _definePage_default_50 from '/opt/render/project/src/src/pages/admin/patrocinio/cadastrar/index.vue?definePage&vue'
import _definePage_default_51 from '/opt/render/project/src/src/pages/admin/patrocinio/editar/[id].vue?definePage&vue'
import _definePage_default_52 from '/opt/render/project/src/src/pages/admin/pergunta-resposta/index.vue?definePage&vue'
import _definePage_default_53 from '/opt/render/project/src/src/pages/admin/pergunta-resposta/cadastrar/index.vue?definePage&vue'
import _definePage_default_54 from '/opt/render/project/src/src/pages/admin/pergunta-resposta/editar/[id].vue?definePage&vue'
import _definePage_default_55 from '/opt/render/project/src/src/pages/admin/pesquisa-avancada/index.vue?definePage&vue'
import _definePage_default_56 from '/opt/render/project/src/src/pages/admin/plano/index.vue?definePage&vue'
import _definePage_default_57 from '/opt/render/project/src/src/pages/admin/plano/cadastrar/index.vue?definePage&vue'
import _definePage_default_58 from '/opt/render/project/src/src/pages/admin/plano/editar/[id].vue?definePage&vue'
import _definePage_default_59 from '/opt/render/project/src/src/pages/admin/produto/index.vue?definePage&vue'
import _definePage_default_60 from '/opt/render/project/src/src/pages/admin/produto/cadastrar/index.vue?definePage&vue'
import _definePage_default_61 from '/opt/render/project/src/src/pages/admin/produto/editar/[id].vue?definePage&vue'
import _definePage_default_62 from '/opt/render/project/src/src/pages/admin/profile/[tab].vue?definePage&vue'
import _definePage_default_63 from '/opt/render/project/src/src/pages/admin/selecionar-plano/[id].vue?definePage&vue'
import _definePage_default_64 from '/opt/render/project/src/src/pages/admin/servico/index.vue?definePage&vue'
import _definePage_default_65 from '/opt/render/project/src/src/pages/admin/servico/cadastrar/index.vue?definePage&vue'
import _definePage_default_66 from '/opt/render/project/src/src/pages/admin/servico/editar/[id].vue?definePage&vue'
import _definePage_default_67 from '/opt/render/project/src/src/pages/admin/settings/[tab].vue?definePage&vue'
import _definePage_default_68 from '/opt/render/project/src/src/pages/admin/tipo-evento/index.vue?definePage&vue'
import _definePage_default_69 from '/opt/render/project/src/src/pages/admin/tipo-evento/cadastrar/index.vue?definePage&vue'
import _definePage_default_70 from '/opt/render/project/src/src/pages/admin/tipo-evento/editar/[id].vue?definePage&vue'
import _definePage_default_71 from '/opt/render/project/src/src/pages/admin/users/index.vue?definePage&vue'
import _definePage_default_72 from '/opt/render/project/src/src/pages/admin/users/cadastrar/index.vue?definePage&vue'
import _definePage_default_73 from '/opt/render/project/src/src/pages/admin/users/editar/[id].vue?definePage&vue'
import _definePage_default_74 from '/opt/render/project/src/src/pages/calendario/index.vue?definePage&vue'
import _definePage_default_75 from '/opt/render/project/src/src/pages/convite/[token].vue?definePage&vue'
import _definePage_default_76 from '/opt/render/project/src/src/pages/fornecedor/dashboard/impressoes.vue?definePage&vue'
import _definePage_default_77 from '/opt/render/project/src/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_78 from '/opt/render/project/src/src/pages/pesquisar/index.vue?definePage&vue'
import _definePage_default_79 from '/opt/render/project/src/src/pages/planos.vue?definePage&vue'
import _definePage_default_80 from '/opt/render/project/src/src/pages/politica-privacidade.vue?definePage&vue'
import _definePage_default_81 from '/opt/render/project/src/src/pages/sobre/index.vue?definePage&vue'
import _definePage_default_82 from '/opt/render/project/src/src/pages/termos-e-politicas.vue?definePage&vue'
import _definePage_default_83 from '/opt/render/project/src/src/pages/termos-uso.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/opt/render/project/src/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/opt/render/project/src/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'admin',
        component: () => import('/opt/render/project/src/src/pages/admin/index.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
      {
        path: 'acesso',
        /* internal name: 'admin-acesso' */
        /* no component */
        children: [
          {
            path: 'perfis',
            /* internal name: 'admin-acesso-perfis' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-acesso-perfis',
                component: () => import('/opt/render/project/src/src/pages/admin/acesso/perfis/index.vue'),
                /* no children */
              },
  _definePage_default_4
  ),
              {
                path: 'components',
                /* internal name: 'admin-acesso-perfis-components' */
                /* no component */
                children: [
                  {
                    path: 'AddEditRoleDialog',
                    name: 'admin-acesso-perfis-components-add-edit-role-dialog',
                    component: () => import('/opt/render/project/src/src/pages/admin/acesso/perfis/components/AddEditRoleDialog.vue'),
                    /* no children */
                  },
                  {
                    path: 'RoleCards',
                    name: 'admin-acesso-perfis-components-role-cards',
                    component: () => import('/opt/render/project/src/src/pages/admin/acesso/perfis/components/RoleCards.vue'),
                    /* no children */
                  },
                  {
                    path: 'UserList',
                    name: 'admin-acesso-perfis-components-user-list',
                    component: () => import('/opt/render/project/src/src/pages/admin/acesso/perfis/components/UserList.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'permissoes',
            /* internal name: 'admin-acesso-permissoes' */
            /* no component */
            children: [
              {
                path: '',
                name: 'admin-acesso-permissoes',
                component: () => import('/opt/render/project/src/src/pages/admin/acesso/permissoes/index.vue'),
                /* no children */
              },
              {
                path: 'components',
                /* internal name: 'admin-acesso-permissoes-components' */
                /* no component */
                children: [
                  {
                    path: 'AddEditPermissionDialog',
                    name: 'admin-acesso-permissoes-components-add-edit-permission-dialog',
                    component: () => import('/opt/render/project/src/src/pages/admin/acesso/permissoes/components/AddEditPermissionDialog.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'auth',
        /* internal name: 'admin-auth' */
        /* no component */
        children: [
          {
            path: 'cadastrar',
            /* internal name: 'admin-auth-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-auth-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/auth/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_5
  ),
              {
                path: 'components',
                /* internal name: 'admin-auth-cadastrar-components' */
                /* no component */
                children: [
                  {
                    path: 'TermosModal',
                    name: 'admin-auth-cadastrar-components-termos-modal',
                    component: () => import('/opt/render/project/src/src/pages/admin/auth/cadastrar/components/TermosModal.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'esqueceu-senha',
            /* internal name: 'admin-auth-esqueceu-senha' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-auth-esqueceu-senha',
                component: () => import('/opt/render/project/src/src/pages/admin/auth/esqueceu-senha/index.vue'),
                /* no children */
              },
  _definePage_default_6
  )
            ],
          },
          {
            path: 'login',
            /* internal name: 'admin-auth-login' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-auth-login',
                component: () => import('/opt/render/project/src/src/pages/admin/auth/login/index.vue'),
                /* no children */
              },
  _definePage_default_7
  )
            ],
          },
          {
            path: 'redefinir-senha',
            /* internal name: 'admin-auth-redefinir-senha' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-auth-redefinir-senha',
                component: () => import('/opt/render/project/src/src/pages/admin/auth/redefinir-senha/index.vue'),
                /* no children */
              },
  _definePage_default_8
  )
            ],
          },
          {
            path: 'verificar-email',
            /* internal name: 'admin-auth-verificar-email' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-auth-verificar-email',
                component: () => import('/opt/render/project/src/src/pages/admin/auth/verificar-email/index.vue'),
                /* no children */
              },
  _definePage_default_9
  )
            ],
          }
        ],
      },
      {
        path: 'banner',
        /* internal name: 'admin-banner' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-banner',
            component: () => import('/opt/render/project/src/src/pages/admin/banner/index.vue'),
            /* no children */
          },
  _definePage_default_10
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-banner-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-banner-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/banner/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_11
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-banner-components' */
            /* no component */
            children: [
              {
                path: 'banner-actions',
                name: 'admin-banner-components-banner-actions',
                component: () => import('/opt/render/project/src/src/pages/admin/banner/components/banner-actions.vue'),
                /* no children */
              },
              {
                path: 'form-banner',
                name: 'admin-banner-components-form-banner',
                component: () => import('/opt/render/project/src/src/pages/admin/banner/components/form-banner.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-banner-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-banner-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/banner/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_12
  )
            ],
          }
        ],
      },
      {
        path: 'categoria-espaco-evento',
        /* internal name: 'admin-categoria-espaco-evento' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-categoria-espaco-evento',
            component: () => import('/opt/render/project/src/src/pages/admin/categoria-espaco-evento/index.vue'),
            /* no children */
          },
  _definePage_default_13
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-categoria-espaco-evento-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-categoria-espaco-evento-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-espaco-evento/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_14
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-categoria-espaco-evento-components' */
            /* no component */
            children: [
              {
                path: 'form-categoria-espaco-evento',
                name: 'admin-categoria-espaco-evento-components-form-categoria-espaco-evento',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-espaco-evento/components/form-categoria-espaco-evento.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-categoria-espaco-evento-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-categoria-espaco-evento-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-espaco-evento/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_15
  )
            ],
          }
        ],
      },
      {
        path: 'categoria-experiencia',
        /* internal name: 'admin-categoria-experiencia' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-categoria-experiencia',
            component: () => import('/opt/render/project/src/src/pages/admin/categoria-experiencia/index.vue'),
            /* no children */
          },
  _definePage_default_16
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-categoria-experiencia-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-categoria-experiencia-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-experiencia/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_17
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-categoria-experiencia-components' */
            /* no component */
            children: [
              {
                path: 'form-categoria-experiencia',
                name: 'admin-categoria-experiencia-components-form-categoria-experiencia',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-experiencia/components/form-categoria-experiencia.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-categoria-experiencia-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-categoria-experiencia-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-experiencia/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_18
  )
            ],
          }
        ],
      },
      {
        path: 'categoria-fornecedor',
        /* internal name: 'admin-categoria-fornecedor' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-categoria-fornecedor',
            component: () => import('/opt/render/project/src/src/pages/admin/categoria-fornecedor/index.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-categoria-fornecedor-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-categoria-fornecedor-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-fornecedor/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_20
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-categoria-fornecedor-components' */
            /* no component */
            children: [
              {
                path: 'form-categoria',
                name: 'admin-categoria-fornecedor-components-form-categoria',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-fornecedor/components/form-categoria.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-categoria-fornecedor-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-categoria-fornecedor-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-fornecedor/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_21
  )
            ],
          }
        ],
      },
      {
        path: 'categoria-produto',
        /* internal name: 'admin-categoria-produto' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-categoria-produto',
            component: () => import('/opt/render/project/src/src/pages/admin/categoria-produto/index.vue'),
            /* no children */
          },
  _definePage_default_22
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-categoria-produto-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-categoria-produto-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-produto/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_23
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-categoria-produto-components' */
            /* no component */
            children: [
              {
                path: 'form-categoriaproduto',
                name: 'admin-categoria-produto-components-form-categoriaproduto',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-produto/components/form-categoriaproduto.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-categoria-produto-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-categoria-produto-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-produto/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_24
  )
            ],
          }
        ],
      },
      {
        path: 'categoria-servico',
        /* internal name: 'admin-categoria-servico' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-categoria-servico',
            component: () => import('/opt/render/project/src/src/pages/admin/categoria-servico/index.vue'),
            /* no children */
          },
  _definePage_default_25
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-categoria-servico-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-categoria-servico-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-servico/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_26
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-categoria-servico-components' */
            /* no component */
            children: [
              {
                path: 'form-categoriaservico',
                name: 'admin-categoria-servico-components-form-categoriaservico',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-servico/components/form-categoriaservico.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-categoria-servico-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-categoria-servico-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/categoria-servico/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_27
  )
            ],
          }
        ],
      },
      {
        path: 'comodidade',
        /* internal name: 'admin-comodidade' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-comodidade',
            component: () => import('/opt/render/project/src/src/pages/admin/comodidade/index.vue'),
            /* no children */
          },
  _definePage_default_28
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-comodidade-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-comodidade-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/comodidade/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_29
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-comodidade-components' */
            /* no component */
            children: [
              {
                path: 'form-comodidade',
                name: 'admin-comodidade-components-form-comodidade',
                component: () => import('/opt/render/project/src/src/pages/admin/comodidade/components/form-comodidade.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-comodidade-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-comodidade-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/comodidade/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_30
  )
            ],
          }
        ],
      },
      {
        path: 'convite',
        /* internal name: 'admin-convite' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-convite',
            component: () => import('/opt/render/project/src/src/pages/admin/convite/index.vue'),
            /* no children */
          },
  _definePage_default_31
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-convite-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-convite-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/convite/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_32
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-convite-components' */
            /* no component */
            children: [
              {
                path: 'form-convite',
                name: 'admin-convite-components-form-convite',
                component: () => import('/opt/render/project/src/src/pages/admin/convite/components/form-convite.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'admin-dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-dashboard',
            component: () => import('/opt/render/project/src/src/pages/admin/dashboard/index.vue'),
            /* no children */
          },
          {
            path: 'components',
            /* internal name: 'admin-dashboard-components' */
            /* no component */
            children: [
              {
                path: 'DashboardControls',
                name: 'admin-dashboard-components-dashboard-controls',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardControls.vue'),
                /* no children */
              },
              {
                path: 'DashboardConversionRate',
                name: 'admin-dashboard-components-dashboard-conversion-rate',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardConversionRate.vue'),
                /* no children */
              },
              {
                path: 'DashboardErrorBoundary',
                name: 'admin-dashboard-components-dashboard-error-boundary',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardErrorBoundary.vue'),
                /* no children */
              },
              {
                path: 'DashboardEventsByOrganizer',
                name: 'admin-dashboard-components-dashboard-events-by-organizer',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardEventsByOrganizer.vue'),
                /* no children */
              },
              {
                path: 'DashboardEventStatus',
                name: 'admin-dashboard-components-dashboard-event-status',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardEventStatus.vue'),
                /* no children */
              },
              {
                path: 'DashboardMetricCard',
                name: 'admin-dashboard-components-dashboard-metric-card',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardMetricCard.vue'),
                /* no children */
              },
              {
                path: 'DashboardMetricsCard',
                name: 'admin-dashboard-components-dashboard-metrics-card',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardMetricsCard.vue'),
                /* no children */
              },
              {
                path: 'DashboardNewRegistrations',
                name: 'admin-dashboard-components-dashboard-new-registrations',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardNewRegistrations.vue'),
                /* no children */
              },
              {
                path: 'DashboardOpenCarts',
                name: 'admin-dashboard-components-dashboard-open-carts',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardOpenCarts.vue'),
                /* no children */
              },
              {
                path: 'DashboardPlansCard',
                name: 'admin-dashboard-components-dashboard-plans-card',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardPlansCard.vue'),
                /* no children */
              },
              {
                path: 'DashboardProfileCompletion',
                name: 'admin-dashboard-components-dashboard-profile-completion',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard/components/DashboardProfileCompletion.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'dashboard-fornecedor',
        /* internal name: 'admin-dashboard-fornecedor' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-dashboard-fornecedor',
            component: () => import('/opt/render/project/src/src/pages/admin/dashboard-fornecedor/index.vue'),
            /* no children */
          },
  _definePage_default_33
  ),
          {
            path: 'components',
            /* internal name: 'admin-dashboard-fornecedor-components' */
            /* no component */
            children: [
              {
                path: 'SubscriptionCard',
                name: 'admin-dashboard-fornecedor-components-subscription-card',
                component: () => import('/opt/render/project/src/src/pages/admin/dashboard-fornecedor/components/SubscriptionCard.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'data-bloqueada',
        /* internal name: 'admin-data-bloqueada' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-data-bloqueada',
            component: () => import('/opt/render/project/src/src/pages/admin/data-bloqueada/index.vue'),
            /* no children */
          },
  _definePage_default_34
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-data-bloqueada-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-data-bloqueada-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/data-bloqueada/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_35
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-data-bloqueada-components' */
            /* no component */
            children: [
              {
                path: 'form-databloqueada',
                name: 'admin-data-bloqueada-components-form-databloqueada',
                component: () => import('/opt/render/project/src/src/pages/admin/data-bloqueada/components/form-databloqueada.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-data-bloqueada-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-data-bloqueada-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/data-bloqueada/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          }
        ],
      },
      {
        path: 'espaco-evento',
        /* internal name: 'admin-espaco-evento' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-espaco-evento',
            component: () => import('/opt/render/project/src/src/pages/admin/espaco-evento/index.vue'),
            /* no children */
          },
  _definePage_default_37
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-espaco-evento-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-espaco-evento-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/espaco-evento/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_38
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-espaco-evento-components' */
            /* no component */
            children: [
              {
                path: 'form-espacoevento',
                name: 'admin-espaco-evento-components-form-espacoevento',
                component: () => import('/opt/render/project/src/src/pages/admin/espaco-evento/components/form-espacoevento.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-espaco-evento-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-espaco-evento-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/espaco-evento/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_39
  )
            ],
          }
        ],
      },
      {
        path: 'evento',
        /* internal name: 'admin-evento' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-evento',
            component: () => import('/opt/render/project/src/src/pages/admin/evento/index.vue'),
            /* no children */
          },
  _definePage_default_40
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-evento-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-evento-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/evento/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_41
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-evento-components' */
            /* no component */
            children: [
              {
                path: 'form-evento',
                name: 'admin-evento-components-form-evento',
                component: () => import('/opt/render/project/src/src/pages/admin/evento/components/form-evento.vue'),
                /* no children */
              },
              {
                path: 'Kanban',
                name: 'admin-evento-components-kanban',
                component: () => import('/opt/render/project/src/src/pages/admin/evento/components/Kanban.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-evento-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-evento-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/evento/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_42
  )
            ],
          }
        ],
      },
      {
        path: 'fornecedor',
        /* internal name: 'admin-fornecedor' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-fornecedor',
            component: () => import('/opt/render/project/src/src/pages/admin/fornecedor/index.vue'),
            /* no children */
          },
  _definePage_default_43
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-fornecedor-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-fornecedor-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/fornecedor/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_44
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-fornecedor-components' */
            /* no component */
            children: [
              {
                path: 'form-fornecedor',
                name: 'admin-fornecedor-components-form-fornecedor',
                component: () => import('/opt/render/project/src/src/pages/admin/fornecedor/components/form-fornecedor.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-fornecedor-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-fornecedor-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/fornecedor/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_45
  )
            ],
          }
        ],
      },
      {
        path: 'galeria',
        /* internal name: 'admin-galeria' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-galeria',
            component: () => import('/opt/render/project/src/src/pages/admin/galeria/index.vue'),
            /* no children */
          },
  _definePage_default_46
  )
        ],
      },
      {
        path: 'meu-plano',
        /* internal name: 'admin-meu-plano' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-meu-plano',
            component: () => import('/opt/render/project/src/src/pages/admin/meu-plano/index.vue'),
            /* no children */
          },
  _definePage_default_47
  )
        ],
      },
      {
        path: 'minhas-assinaturas',
        /* internal name: 'admin-minhas-assinaturas' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-minhas-assinaturas',
            component: () => import('/opt/render/project/src/src/pages/admin/minhas-assinaturas/index.vue'),
            /* no children */
          },
  _definePage_default_48
  )
        ],
      },
      {
        path: 'patrocinio',
        /* internal name: 'admin-patrocinio' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-patrocinio',
            component: () => import('/opt/render/project/src/src/pages/admin/patrocinio/index.vue'),
            /* no children */
          },
  _definePage_default_49
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-patrocinio-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-patrocinio-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/patrocinio/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_50
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-patrocinio-components' */
            /* no component */
            children: [
              {
                path: 'form-patrocinio',
                name: 'admin-patrocinio-components-form-patrocinio',
                component: () => import('/opt/render/project/src/src/pages/admin/patrocinio/components/form-patrocinio.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-patrocinio-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-patrocinio-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/patrocinio/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_51
  )
            ],
          }
        ],
      },
      {
        path: 'pergunta-resposta',
        /* internal name: 'admin-pergunta-resposta' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-pergunta-resposta',
            component: () => import('/opt/render/project/src/src/pages/admin/pergunta-resposta/index.vue'),
            /* no children */
          },
  _definePage_default_52
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-pergunta-resposta-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-pergunta-resposta-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/pergunta-resposta/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_53
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-pergunta-resposta-components' */
            /* no component */
            children: [
              {
                path: 'form-pergunta-resposta',
                name: 'admin-pergunta-resposta-components-form-pergunta-resposta',
                component: () => import('/opt/render/project/src/src/pages/admin/pergunta-resposta/components/form-pergunta-resposta.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-pergunta-resposta-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-pergunta-resposta-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/pergunta-resposta/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_54
  )
            ],
          }
        ],
      },
      {
        path: 'pesquisa-avancada',
        /* internal name: 'admin-pesquisa-avancada' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-pesquisa-avancada',
            component: () => import('/opt/render/project/src/src/pages/admin/pesquisa-avancada/index.vue'),
            /* no children */
          },
  _definePage_default_55
  ),
          {
            path: 'components',
            /* internal name: 'admin-pesquisa-avancada-components' */
            /* no component */
            children: [
              {
                path: 'AdicionarEventoDialog',
                name: 'admin-pesquisa-avancada-components-adicionar-evento-dialog',
                component: () => import('/opt/render/project/src/src/pages/admin/pesquisa-avancada/components/AdicionarEventoDialog.vue'),
                /* no children */
              },
              {
                path: 'FornecedorCard',
                name: 'admin-pesquisa-avancada-components-fornecedor-card',
                component: () => import('/opt/render/project/src/src/pages/admin/pesquisa-avancada/components/FornecedorCard.vue'),
                /* no children */
              },
              {
                path: 'FornecedorDetalhesDialog',
                name: 'admin-pesquisa-avancada-components-fornecedor-detalhes-dialog',
                component: () => import('/opt/render/project/src/src/pages/admin/pesquisa-avancada/components/FornecedorDetalhesDialog.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'plano',
        /* internal name: 'admin-plano' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-plano',
            component: () => import('/opt/render/project/src/src/pages/admin/plano/index.vue'),
            /* no children */
          },
  _definePage_default_56
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-plano-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-plano-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/plano/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_57
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-plano-components' */
            /* no component */
            children: [
              {
                path: 'form-plano',
                name: 'admin-plano-components-form-plano',
                component: () => import('/opt/render/project/src/src/pages/admin/plano/components/form-plano.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-plano-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-plano-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/plano/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_58
  )
            ],
          }
        ],
      },
      {
        path: 'produto',
        /* internal name: 'admin-produto' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-produto',
            component: () => import('/opt/render/project/src/src/pages/admin/produto/index.vue'),
            /* no children */
          },
  _definePage_default_59
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-produto-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-produto-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/produto/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_60
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-produto-components' */
            /* no component */
            children: [
              {
                path: 'form-produto',
                name: 'admin-produto-components-form-produto',
                component: () => import('/opt/render/project/src/src/pages/admin/produto/components/form-produto.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-produto-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-produto-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/produto/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_61
  )
            ],
          }
        ],
      },
      {
        path: 'profile',
        /* internal name: 'admin-profile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'admin-profile-tab',
            component: () => import('/opt/render/project/src/src/pages/admin/profile/[tab].vue'),
            /* no children */
          },
  _definePage_default_62
  ),
          {
            path: 'components',
            /* internal name: 'admin-profile-components' */
            /* no component */
            children: [
              {
                path: 'AccountSettingsAccount',
                name: 'admin-profile-components-account-settings-account',
                component: () => import('/opt/render/project/src/src/pages/admin/profile/components/AccountSettingsAccount.vue'),
                /* no children */
              },
              {
                path: 'AccountSettingsBillingAndPlans',
                name: 'admin-profile-components-account-settings-billing-and-plans',
                component: () => import('/opt/render/project/src/src/pages/admin/profile/components/AccountSettingsBillingAndPlans.vue'),
                /* no children */
              },
              {
                path: 'AccountSettingsSecurity',
                name: 'admin-profile-components-account-settings-security',
                component: () => import('/opt/render/project/src/src/pages/admin/profile/components/AccountSettingsSecurity.vue'),
                /* no children */
              },
              {
                path: 'BillingHistoryTable',
                name: 'admin-profile-components-billing-history-table',
                component: () => import('/opt/render/project/src/src/pages/admin/profile/components/BillingHistoryTable.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'selecionar-plano',
        /* internal name: 'admin-selecionar-plano' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'admin-selecionar-plano-id',
            component: () => import('/opt/render/project/src/src/pages/admin/selecionar-plano/[id].vue'),
            /* no children */
          },
  _definePage_default_63
  ),
          {
            path: 'components',
            /* internal name: 'admin-selecionar-plano-components' */
            /* no component */
            children: [
              {
                path: 'CreditCard',
                name: 'admin-selecionar-plano-components-credit-card',
                component: () => import('/opt/render/project/src/src/pages/admin/selecionar-plano/components/CreditCard.vue'),
                /* no children */
              },
              {
                path: 'step-1',
                name: 'admin-selecionar-plano-components-step1',
                component: () => import('/opt/render/project/src/src/pages/admin/selecionar-plano/components/step-1.vue'),
                /* no children */
              },
              {
                path: 'step-2',
                name: 'admin-selecionar-plano-components-step2',
                component: () => import('/opt/render/project/src/src/pages/admin/selecionar-plano/components/step-2.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'servico',
        /* internal name: 'admin-servico' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-servico',
            component: () => import('/opt/render/project/src/src/pages/admin/servico/index.vue'),
            /* no children */
          },
  _definePage_default_64
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-servico-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-servico-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/servico/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_65
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-servico-components' */
            /* no component */
            children: [
              {
                path: 'form-servico',
                name: 'admin-servico-components-form-servico',
                component: () => import('/opt/render/project/src/src/pages/admin/servico/components/form-servico.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-servico-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-servico-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/servico/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_66
  )
            ],
          }
        ],
      },
      {
        path: 'settings',
        /* internal name: 'admin-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'admin-settings-tab',
            component: () => import('/opt/render/project/src/src/pages/admin/settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_67
  ),
          {
            path: 'components',
            /* internal name: 'admin-settings-components' */
            /* no component */
            children: [
              {
                path: 'AccountSettingsConnections',
                name: 'admin-settings-components-account-settings-connections',
                component: () => import('/opt/render/project/src/src/pages/admin/settings/components/AccountSettingsConnections.vue'),
                /* no children */
              },
              {
                path: 'AccountSettingsNotification',
                name: 'admin-settings-components-account-settings-notification',
                component: () => import('/opt/render/project/src/src/pages/admin/settings/components/AccountSettingsNotification.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'tipo-evento',
        /* internal name: 'admin-tipo-evento' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-tipo-evento',
            component: () => import('/opt/render/project/src/src/pages/admin/tipo-evento/index.vue'),
            /* no children */
          },
  _definePage_default_68
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-tipo-evento-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-tipo-evento-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/tipo-evento/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_69
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-tipo-evento-components' */
            /* no component */
            children: [
              {
                path: 'form-tipoevento',
                name: 'admin-tipo-evento-components-form-tipoevento',
                component: () => import('/opt/render/project/src/src/pages/admin/tipo-evento/components/form-tipoevento.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-tipo-evento-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-tipo-evento-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/tipo-evento/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_70
  )
            ],
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'admin-users' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-users',
            component: () => import('/opt/render/project/src/src/pages/admin/users/index.vue'),
            /* no children */
          },
  _definePage_default_71
  ),
          {
            path: 'cadastrar',
            /* internal name: 'admin-users-cadastrar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'admin-users-cadastrar',
                component: () => import('/opt/render/project/src/src/pages/admin/users/cadastrar/index.vue'),
                /* no children */
              },
  _definePage_default_72
  )
            ],
          },
          {
            path: 'components',
            /* internal name: 'admin-users-components' */
            /* no component */
            children: [
              {
                path: 'form-users',
                name: 'admin-users-components-form-users',
                component: () => import('/opt/render/project/src/src/pages/admin/users/components/form-users.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'editar',
            /* internal name: 'admin-users-editar' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'admin-users-editar-id',
                component: () => import('/opt/render/project/src/src/pages/admin/users/editar/[id].vue'),
                /* no children */
              },
  _definePage_default_73
  )
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/calendario',
    /* internal name: 'calendario' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'calendario',
        component: () => import('/opt/render/project/src/src/pages/calendario/index.vue'),
        /* no children */
      },
  _definePage_default_74
  )
    ],
  },
  {
    path: '/convite',
    /* internal name: 'convite' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':token',
        name: 'convite-token',
        component: () => import('/opt/render/project/src/src/pages/convite/[token].vue'),
        /* no children */
      },
  _definePage_default_75
  )
    ],
  },
  {
    path: '/fornecedor',
    /* internal name: 'fornecedor' */
    /* no component */
    children: [
      {
        path: 'dashboard',
        /* internal name: 'fornecedor-dashboard' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'impressoes',
            name: 'fornecedor-dashboard-impressoes',
            component: () => import('/opt/render/project/src/src/pages/fornecedor/dashboard/impressoes.vue'),
            /* no children */
          },
  _definePage_default_76
  )
        ],
      }
    ],
  },
  {
    path: '/landing-page',
    /* internal name: 'landing-page' */
    /* no component */
    children: [
      {
        path: 'components',
        /* internal name: 'landing-page-components' */
        /* no component */
        children: [
          {
            path: 'SolicitarPinDialog',
            name: 'landing-page-components-solicitar-pin-dialog',
            component: () => import('/opt/render/project/src/src/pages/landing-page/components/SolicitarPinDialog.vue'),
            /* no children */
          },
          {
            path: 'ValidarPinDialog',
            name: 'landing-page-components-validar-pin-dialog',
            component: () => import('/opt/render/project/src/src/pages/landing-page/components/ValidarPinDialog.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sections',
        /* internal name: 'landing-page-sections' */
        /* no component */
        children: [
          {
            path: 'EventStatusSection',
            name: 'landing-page-sections-event-status-section',
            component: () => import('/opt/render/project/src/src/pages/landing-page/sections/EventStatusSection.vue'),
            /* no children */
          },
          {
            path: 'ExperienceSection',
            name: 'landing-page-sections-experience-section',
            component: () => import('/opt/render/project/src/src/pages/landing-page/sections/ExperienceSection.vue'),
            /* no children */
          },
          {
            path: 'FeaturedCompaniesSection',
            name: 'landing-page-sections-featured-companies-section',
            component: () => import('/opt/render/project/src/src/pages/landing-page/sections/FeaturedCompaniesSection.vue'),
            /* no children */
          },
          {
            path: 'PricingSection',
            name: 'landing-page-sections-pricing-section',
            component: () => import('/opt/render/project/src/src/pages/landing-page/sections/PricingSection.vue'),
            /* no children */
          },
          {
            path: 'SearchedCompaniesSection',
            name: 'landing-page-sections-searched-companies-section',
            component: () => import('/opt/render/project/src/src/pages/landing-page/sections/SearchedCompaniesSection.vue'),
            /* no children */
          },
          {
            path: 'SearchSection',
            name: 'landing-page-sections-search-section',
            component: () => import('/opt/render/project/src/src/pages/landing-page/sections/SearchSection.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/opt/render/project/src/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_77
  ),
  {
    path: '/pesquisar',
    /* internal name: 'pesquisar' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pesquisar',
        component: () => import('/opt/render/project/src/src/pages/pesquisar/index.vue'),
        /* no children */
      },
  _definePage_default_78
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/planos',
    name: 'planos',
    component: () => import('/opt/render/project/src/src/pages/planos.vue'),
    /* no children */
  },
  _definePage_default_79
  ),
  _mergeRouteRecord(
  {
    path: '/politica-privacidade',
    name: 'politica-privacidade',
    component: () => import('/opt/render/project/src/src/pages/politica-privacidade.vue'),
    /* no children */
  },
  _definePage_default_80
  ),
  {
    path: '/sobre',
    /* internal name: 'sobre' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'sobre',
        component: () => import('/opt/render/project/src/src/pages/sobre/index.vue'),
        /* no children */
      },
  _definePage_default_81
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/termos-e-politicas',
    name: 'termos-epoliticas',
    component: () => import('/opt/render/project/src/src/pages/termos-e-politicas.vue'),
    /* no children */
  },
  _definePage_default_82
  ),
  _mergeRouteRecord(
  {
    path: '/termos-uso',
    name: 'termos-uso',
    component: () => import('/opt/render/project/src/src/pages/termos-uso.vue'),
    /* no children */
  },
  _definePage_default_83
  )
]
